import { Link } from 'react-router-dom';
import { site } from '../config/site';

export function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="wrap">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/">
              <img src={site.logoUrl} alt="" width={22} height={28} />
              MindHeart
            </Link>
            <p>
              AI relationship intelligence — know what to say next. Operated by
              Omnivatis.
            </p>
          </div>
          <div className="footer-col">
            <h4>Product</h4>
            <a href="/#glimpse">The app</a>
            <a href="/#loop">How it works</a>
            <a href="/#coach">Coach</a>
            <a href="/#plans">Plans</a>
            <a href={`mailto:${site.supportEmail}`}>Contact</a>
          </div>
          <div className="footer-col">
            <h4>Legal</h4>
            <Link to={site.privacyUrl}>Privacy Policy</Link>
            <Link to={site.termsUrl}>Terms of Use</Link>
            <Link to={site.supportUrl}>Support</Link>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {year} MindHeart · Omnivatis</span>
          <span>
            <Link to={site.privacyUrl}>Privacy</Link> ·{' '}
            <Link to={site.termsUrl}>Terms</Link> ·{' '}
            <Link to={site.supportUrl}>Support</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
